import PropTypes from 'prop-types';
import { useTable, useFilters, useSortBy, usePagination, useGlobalFilter } from 'react-table';
import { useNavigate } from 'react-router-dom';
import { useState, useContext, useEffect, useRef } from 'react';
import { UserContext } from 'contexts/UserContext';
import * as XLSX from 'xlsx';
import ExcelJS from 'exceljs';
import { format } from 'date-fns';
import { saveAs } from 'file-saver';
import { ModalContext } from 'contexts/ModalContext';
import axios from 'axios';
import logoExcelRound from 'assets/img/Excel-2-icon.png';
import logoBorrarRound from 'assets/img/borrarblanc.png';
import logoCheckRound from 'assets/img/checkblancborder.png';
import logoTxt from 'assets/img/txtroundicon.png';
import logoCalendar from 'assets/img/calendar-icon.png';
import logoAltas from 'assets/img/txtroundiconaltas.png'
import logoBajas from 'assets/img/txtroundiconbajas.png'

// COMPONENTS
import FilterUp from 'components/icons/FilterUp';
import FilterDown from 'components/icons/FilterDown';
import SchoolsTableBar from './SchoolsTableBar';
import StudentsTableBar from './StudentsTableBar';
import { FaCalendarAlt } from 'react-icons/fa';
// import { DateRangeColumnFilter } from 'components/ui/Table/DateRangeColumnFilter';

export default function StudentsTable({ data, columns, handleClick, refreshData, duplicateDNIs, overlapRows, monthAdjacentRows }) {
  if (!data) return null; // Asegúrate de que 'data' esté definido
  const { openModal } = useContext(ModalContext);
  const startDateRef = useRef(null); // Referencia para el filtro de fecha de inicio
  const endDateRef = useRef(null); 
  const formRef = useRef(null);

  const navigate = useNavigate();
  const { user } = useContext(UserContext);
  const [selectedRows, setSelectedRows] = useState({});  // Almacena los seleccionados
  const [iniciCheck, setIniciCheck] = useState('');  // Almacena el nuevo estado de INICI_CHECK
  const [fiCheck, setFiCheck] = useState('');  // Almacena el nuevo estado de FI_CHECK
  const [showForm, setShowForm] = useState(false);  // Controla la visibilidad del formulario
  const [filterStatus, setFilterStatus] = useState(''); // Almacena el estado del filtro (habilitados/inhabilitados)
  const [selectAll, setSelectAll] = useState(false); // Estado para controlar selección de todos los checkbox
  


    // Estado para filtros iniciales
  const [initialFilters, setInitialFilters] = useState(() => {
    const storedFilters = localStorage.getItem('studentsTableFilters');
    return storedFilters ? JSON.parse(storedFilters) : [];
  });

  // Función para manejar filtros persistentes
  const handleFiltersChange = (filters) => {
    localStorage.setItem('studentsTableFilters', JSON.stringify(filters));
  };


  const handleCalendarClick = (student) => {
    navigate(`/calendar/${student.ID_ALUMNES}/${student.ID_ESCOLA}/${student.ID_PRACTIQUES}`);
  };


  const handleSelectAll = () => {
  if (!selectAll) {
    const newSelectedRows = {};

    filteredRows
      .filter(row => {
        const isLocked = lockedStudentIds.includes(row.original.ID_ALUMNES);
        if (filterStatus === 'habilitados') return !isLocked;
        if (filterStatus === 'inhabilitados') return isLocked;
        return true;
      })
      .forEach((row) => {
        newSelectedRows[row.original.ID_ALUMNES] = true;
      });

    setSelectedRows(newSelectedRows);
  } else {
    setSelectedRows({});
  }

  setSelectAll(!selectAll);
};

//   const handleSelectAll = () => {
//   const newSelectedRows = {};

//   if (!selectAll) {
//     // Filtrar `filteredRows` según el estado de `filterStatus`
//     filteredRows
//       .filter(row => {
//         const isLocked = lockedStudentIds.includes(row.original.ID_ALUMNES);
//         if (filterStatus === 'habilitados') return !isLocked;
//         if (filterStatus === 'inhabilitados') return isLocked;
//         return true; // Seleccionar todos si `filterStatus` es "" (todos)
//       })
//       .forEach((row) => {
//         newSelectedRows[row.original.ID_ALUMNES] = true;
//       });
//   }

//   setSelectedRows(newSelectedRows);
//   setSelectAll(!selectAll); // Cambiar el estado de selectAll
// };

  // Maneja el clic del checkbox para seleccionar usuarios
  // const handleCheckboxClick = (row) => {
  //   const studentId = row.original.ID_ALUMNES;

  //   setSelectedRows((prev) => {
  //     const newState = {
  //       ...prev,
  //       [studentId]: !prev[studentId], // Alterna el estado seleccionado de la fila
  //     };

  //     return newState;
  //   });
  // };

  const handleCheckboxClick = (row) => {
  const studentId = row.original.ID_ALUMNES;

  setSelectedRows((prev) => {
    const updated = { ...prev };
    if (updated[studentId]) {
      delete updated[studentId]; // desmarca eliminando la clave
    } else {
      updated[studentId] = true; // selecciona
    }
    return updated;
  });
};


  // Función para manejar los cambios en INICI_CHECK y FI_CHECK
  const handleIniciCheckChange = (e) => {
    setIniciCheck(e.target.value);  // Actualiza el estado de INICI_CHECK
  };

  const handleFiCheckChange = (e) => {
    setFiCheck(e.target.value);  // Actualiza el estado de FI_CHECK
  };

  useEffect(() => {
    if (showForm && formRef.current) {
      formRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  }, [showForm]);

   useEffect(() => {
    const hasSelectedRows = Object.keys(selectedRows).some((key) => selectedRows[key]);
    if (!hasSelectedRows) {
      setShowForm(false);
    }
  }, [selectedRows]);


  // const handleApplyChanges = async () => {
  //   const selectedUsers = Object.keys(selectedRows).filter((key) => selectedRows[key]);

  //   if (selectedUsers.length === 0) {
  //     console.log('No hay usuarios seleccionados');
  //     return;
  //   }

  //     // Guardar filtros actuales antes de refreshData
  // const currentFilters = JSON.stringify(filters);
  // localStorage.setItem('studentsTableFilters', currentFilters);
  //   // console.log('Usuarios seleccionados para aplicar cambios:', selectedUsers);

  //   for (const userId of selectedUsers) {
  //     try {
  //       // Comprobar si el usuario está deshabilitado (es decir, en la lista de usuarios bloqueados)
  //       const isLocked = lockedStudentIds.includes(userId);

  //       // Realizar el PATCH solo para prácticas (INICI_CHECK y FI_CHECK) independientemente de `isLocked`
  //       const response = await fetch(process.env.REACT_APP_API_URL + `/students/${userId}`, {
  //         method: 'PATCH',
  //         headers: {
  //           'Content-Type': 'application/json',
  //         },
  //         body: JSON.stringify({
  //           INICI_CHECK: iniciCheck,
  //           FI_CHECK: fiCheck,
  //         }),
  //       });

  //       if (response.ok) {
  //         // console.log(`Usuario ${userId} actualizado con INICI_CHECK: ${iniciCheck}, FI_CHECK: ${fiCheck}`);
  //       } else {
  //         // console.error(`Error al actualizar el usuario ${userId}`);
  //       }
  //     } catch (error) {
  //       // console.error('Error en la solicitud PATCH:', error);
  //     }
  //   }

  //   await refreshData();

  //   const storedFilters = localStorage.getItem('studentsTableFilters');
  // if (storedFilters) {
  //   const parsedFilters = JSON.parse(storedFilters);
  //   setAllFilters(parsedFilters); // Aplica los filtros
  // }
  //   setSelectedRows({});
  //   setShowForm(false);
  // };

  const handleApplyChanges = async () => {
  const selectedUsers = Object.keys(selectedRows).filter((key) => selectedRows[key]);

  if (selectedUsers.length === 0) {
    console.log('No hay usuarios seleccionados');
    return;
  }

  const currentFilters = JSON.stringify(filters);
  localStorage.setItem('studentsTableFilters', currentFilters);

  for (const userId of selectedUsers) {
    try {
      const isLocked = lockedStudentIds.includes(parseInt(userId));

      const body = {};
      if (iniciCheck !== '') body.INICI_CHECK = parseInt(iniciCheck);
      if (fiCheck !== '') body.FI_CHECK = parseInt(fiCheck);

      if (Object.keys(body).length === 0) continue; // Si no hay cambios, no enviar

      const response = await fetch(`${process.env.REACT_APP_API_URL}/students/${userId}`, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(body),
      });

      if (!response.ok) {
        console.error(`Error al actualizar el usuario ${userId}`);
      }
    } catch (error) {
      console.error('Error en la solicitud PATCH:', error);
    }
  }

  await refreshData();

  const storedFilters = localStorage.getItem('studentsTableFilters');
  if (storedFilters) {
    const parsedFilters = JSON.parse(storedFilters);
    setAllFilters(parsedFilters);
  }

  setSelectedRows({});
  setShowForm(false);
  setIniciCheck('');
setFiCheck('');

};


  const fetchLockedStudents = async () => {
    try {
      const response = await fetch( process.env.REACT_APP_API_URL + '/students');
      const students = await response.json();

      // Filtrar los alumnos que tienen ambos CHECK_TASCA_INICI y CHECK_TASCA_FINAL en 1
      const lockedStudents = students.filter(
        (student) => student.CHECK_TASCA_INICI === 1 && student.CHECK_TASCA_FINAL === 1
      );

      return lockedStudents.map(student => student.ID_ALUMNES);  // Devuelve solo los ID_ALUMNES de los bloqueados
    } catch (error) {
      console.error('Error fetching students:', error);
      return [];
    }
  };

    const [lockedStudentIds, setLockedStudentIds] = useState([]);

    useEffect(() => {
      // Obtener los alumnos bloqueados al cargar el componente
      const getLockedStudents = async () => {
        const lockedIds = await fetchLockedStudents();
        setLockedStudentIds(lockedIds);  // Guardar los IDs de los alumnos bloqueados en el estado
      };

      getLockedStudents();
    }, []);

// DESCARGAR EXCEL ALUMNOS SELECCIONADOS PARA LAS PRACTICAS!
const downloadSelectedPractices = async () => {
  const selectedUsers = Object.keys(selectedRows).filter((key) => selectedRows[key]);

  if (selectedUsers.length === 0) {
    console.log('No hay usuarios seleccionados');
    return;
  }

  try {
    const formattedData = [];

    // Obtener los datos para cada usuario seleccionado
    for (const userId of selectedUsers) {
      const response = await fetch(process.env.REACT_APP_API_URL + `/studentsTeacher/${userId}`);
      const userData = await response.json();

      // Formatear las fechas de inicio y fin de prácticas
      const formatDate = (dateString) => {
        if (!dateString) return '';
        const date = new Date(dateString);
        if (isNaN(date)) return '';
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Los meses van del 0 al 11
        const year = date.getFullYear();
        return `${day}-${month}-${year}`;
      };

      formattedData.push({
        "CODI BECARI": userData.CODI_BECARI,
        "DNI NIE PASS": userData.DNI,
        // "COGNOMS": userData.COGNOM,
        "NOM": userData.NOM,
        "INICI PRACTIQUES": formatDate(userData.INICI_PRACTIQUES),
        "FI PRACTIQUES": formatDate(userData.FI_PRACTIQUES),
        "GENER": userData.GENER,
        "FEBRER": userData.FEBRER,
        "MARÇ": userData.MARÇ,
        "ABRIL": userData.ABRIL,
        "MAIG": userData.MAIG,
        "JUNY": userData.JUNY,
        "JULIOL": userData.JULIOL,
        "AGOST": userData.AGOST,
        "SETEMBRE": userData.SETEMBRE,
        "OCTUBRE": userData.OCTUBRE,
        "NOVEMBRE": userData.NOVEMBRE,
        "DESEMBRE": userData.DESEMBRE
      });
    }

    if (formattedData.length === 0) {
      console.log('No se encontraron datos para los usuarios seleccionados');
      return;
    }

    // Crear el archivo Excel con exceljs
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Pràctiques');

    // Definir las columnas
    worksheet.columns = [
      { header: 'CODI BECARI', key: 'CODI BECARI', width: 20 },
      { header: 'DNI NIE PASS', key: 'DNI NIE PASS', width: 20 },
      // { header: 'COGNOMS', key: 'COGNOMS', width: 30 },
      { header: 'NOM', key: 'NOM', width: 30 },
      { header: 'INICI PRACTIQUES', key: 'INICI PRACTIQUES', width: 20 },
      { header: 'FI PRACTIQUES', key: 'FI PRACTIQUES', width: 20 },
      { header: 'GENER', key: 'GENER', width: 10 },
      { header: 'FEBRER', key: 'FEBRER', width: 10 },
      { header: 'MARÇ', key: 'MARÇ', width: 10 },
      { header: 'ABRIL', key: 'ABRIL', width: 10 },
      { header: 'MAIG', key: 'MAIG', width: 10 },
      { header: 'JUNY', key: 'JUNY', width: 10 },
      { header: 'JULIOL', key: 'JULIOL', width: 10 },
      { header: 'AGOST', key: 'AGOST', width: 10 },
      { header: 'SETEMBRE', key: 'SETEMBRE', width: 10 },
      { header: 'OCTUBRE', key: 'OCTUBRE', width: 10 },
      { header: 'NOVEMBRE', key: 'NOVEMBRE', width: 10 },
      { header: 'DESEMBRE', key: 'DESEMBRE', width: 10 }
    ];

    // Rellenar los datos
    formattedData.forEach((data) => {
      worksheet.addRow(data);
    });

    worksheet.eachRow((row) => {
      row.height = 25; // Altura específica para todas las filas
    });

    worksheet.getRow(1).eachCell((cell) => {
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFFFCC00' }  // Color amarillo
      };
      cell.font = { bold: true, color: { argb: 'FF0000FF' } };  // Texto en negrita y azul
      cell.alignment = { vertical: 'middle', horizontal: 'center' };  // Alinear en el centro
    });

    // Aplicar validación de datos a las columnas de meses
    const monthColumns = ['GENER', 'FEBRER', 'MARÇ', 'ABRIL', 'MAIG', 'JUNY', 'JULIOL', 'AGOST', 'SETEMBRE', 'OCTUBRE', 'NOVEMBRE', 'DESEMBRE'];

    monthColumns.forEach((col) => {
      worksheet.getColumn(col).eachCell((cell, rowNumber) => {
        if (rowNumber !== 1) {  // Excluir la cabecera
          cell.fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'FFCCE5FF' }  // Color azul claro
          };
        }

        cell.protection = { locked: false };  // Hacer la columna editable

        // Agregar validación de datos para que solo acepte valores entre 0 y 30, sin decimales
        cell.dataValidation = {
          type: 'whole',
          operator: 'between',
          formulae : [ 0 ,  30 ], 
          showErrorMessage: true,
          errorTitle: 'Valor inválido',
          error: 'Por favor, ingresa un número entero entre 0 y 30.',
        };
      });
    });

    // Aplicar color amarillo pastel a "CODI BECARI", "DNI", "NOM" y "COGNOMS"
    // ['CODI BECARI', 'DNI NIE PASS', 'NOM', 'COGNOMS', 'INICI PRACTIQUES', 'FI PRACTIQUES'].forEach((col) => {
    ['CODI BECARI', 'DNI NIE PASS', 'NOM', 'INICI PRACTIQUES', 'FI PRACTIQUES'].forEach((col) => {
      worksheet.getColumn(col).eachCell((cell, rowNumber) => {
        if (rowNumber !== 1) {  // Excluir la cabecera
          cell.fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'FFFFF2CC' }  // Color amarillo pastel
          };
        }
      });
    });

    // Bloquear la hoja para proteger las celdas no editables
    worksheet.protect('Gest1net+Cod1na', {
      selectLockedCells: true,
      selectUnlockedCells: true,
    });

    // Generar el archivo Excel
    const buffer = await workbook.xlsx.writeBuffer();
    const blobData = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    saveAs(blobData, 'Practiques_Seleccionades.xlsx');

  } catch (error) {
    console.error('Error al descargar las prácticas:', error);
  }
};

function dateBetweenFilterFn(rows, id, filterValue) {
  if (!Array.isArray(rows)) {
    console.error("rows no es un array:", rows);
    return [];
  }

  if (!Array.isArray(filterValue)) {
      // console.error("filterValue no es un array válido:", filterValue);
      return rows;
  }

  let [min, max] = filterValue;

  // Convertimos min y max a formato Date de JavaScript (YYYY-MM-DD)
  min = min ? new Date(min) : undefined;
  max = max ? new Date(max) : undefined;

  return rows.filter(row => {
    const rowDate = row.values[id];
    if (!rowDate || typeof rowDate !== 'string') {
      // console.warn(`Fecha inválida en row.values[${id}]:`, rowDate);
      return false;
    }

    // Convertimos la fecha del row de DD-MM-YYYY a YYYY-MM-DD
    const [day, month, year] = rowDate.split('-');
    if (!day || !month || !year) {
      console.warn(`Formato de fecha incorrecto: ${rowDate}`);
      return false;
    }

    const parsedRowDate = new Date(`${year}-${month}-${day}`);

    return (
      (min ? parsedRowDate >= min : true) &&
      (max ? parsedRowDate <= max : true)
    );
  });
}


  // function dateBetweenFilterFn(rows, id, filterValue) {
  //   let [min, max] = filterValue;

  //   // Convertimos min y max a formato Date de JavaScript (YYYY-MM-DD)
  //   min = min ? new Date(min) : undefined;
  //   max = max ? new Date(max) : undefined;

  //   return rows.filter(row => {
  //     const rowDate = row.values[id];
  //     // Aquí convertimos la fecha del row (que está en formato DD-MM-YYYY) a YYYY-MM-DD para la comparación
  //     const [day, month, year] = rowDate.split('-');
  //     const parsedRowDate = new Date(`${year}-${month}-${day}`);

  //     return (
  //       (min ? parsedRowDate >= min : true) &&
  //       (max ? parsedRowDate <= max : true)
  //     );
  //   });
  // }

  // dateBetweenFilterFn.autoRemove = val => !val; // Remueve el filtro si no hay valores


const handleDeleteModalForSelected = () => {
  const selectedIds = Object.keys(selectedRows)
    .filter((key) => selectedRows[key]) // Filtrar IDs seleccionados
    .map((key) => parseInt(key, 10)); // Convertir a números

  if (selectedIds.length === 0) {
    console.log('No hay alumnos seleccionados para eliminar');
    return;
  }

  // Datos para el modal de confirmación
  const modalData = {
    ids: selectedIds,
    handleDelete: () => handleDeleteSelected(selectedIds), // Pasar los IDs seleccionados a la función de eliminación
    type: 'DELETE',
  };

  openModal(modalData); // Abre el modal con los datos
};

// funcion eliminar alumnos seleccionados
const handleDeleteSelected = async (selectedIds) => {
  try {
    for (const id of selectedIds) {
      const url = `${process.env.REACT_APP_API_URL}/students/${id}`;
      await axios.delete(url); // Eliminar cada ID seleccionado
    }

    console.log(`Alumnos eliminados: ${selectedIds.join(', ')}`);
    await refreshData(); // Refrescar los datos después de eliminar
    setSelectedRows({}); // Limpiar las selecciones
  } catch (error) {
    console.error('Error al eliminar alumnos:', error);
  }
};

// funcion de descargar alumnos seleccionados
const downloadSelectedStudents = async () => {
  const selectedIds = Object.keys(selectedRows).filter((key) => selectedRows[key]);

  if (selectedIds.length === 0) {
    console.log('No hay alumnos seleccionados para descargar');
    return;
  }

  try {
    // Obtener datos de todos los alumnos
    const response = await fetch(process.env.REACT_APP_API_URL + '/students/all');
    const allStudents = await response.json();

    // Filtrar los datos de los alumnos seleccionados
    const formattedData = selectedIds.map((id) => {
      const student = allStudents.find((student) => student.ID_ALUMNES === parseInt(id));
      if (!student) return null;

      // Formatear las fechas
      const formatDate = (dateString) => {
        if (!dateString) return '';
        const date = new Date(dateString);
        return format(date, 'dd-MM-yyyy');
      };

      return {
        CodiBecari: student.CODI_BECARI,
        CodiCentre: student.CODI_CENTRE,
        CognomsNom: student.COGNOMS_NOM,
        DNI: student.DNI_NIE_PASSAPORT,
        NumSS: student.NUM_SS,
        DataNaixament: formatDate(student.DATA_NAIXAMENT),
        DataInici: formatDate(student.DATA_INICI),
        DataFinalitzacio: formatDate(student.DATA_FINALITZACIO),
        CheckTascaInici: student.CHECK_TASCA_INICI,
        CheckTascaFinal: student.CHECK_TASCA_FINAL,
        Observacions: student.OBSERVACIONS_ALUMNE || '',
        Gener: student.January || 0,
        Febrer: student.February || 0,
        Març: student.March || 0,
        Abril: student.April || 0,
        Maig: student.May || 0,
        Juny: student.June || 0,
        Juliol: student.July || 0,
        Agost: student.August || 0,
        Setembre: student.September || 0,
        Octubre: student.October || 0,
        Novembre: student.November || 0,
        Desembre: student.December || 0,
      };
    }).filter(Boolean);

    // Crear el archivo Excel con ExcelJS
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Alumnes Seleccionats');

    // Definir columnas y estilos
    worksheet.columns = [
      { header: 'Codi Becari', key: 'CodiBecari', width: 15 },
      { header: 'Codi Centre', key: 'CodiCentre', width: 15 },
      { header: 'Cognoms Nom', key: 'CognomsNom', width: 50 },
      { header: 'DNI', key: 'DNI', width: 15 },
      { header: 'Numero Seguretat Social', key: 'NumSS', width: 25 },
      { header: 'Data Naixement', key: 'DataNaixament', width: 15 },
      { header: 'Inici Pràctiques', key: 'DataInici', width: 15 },
      { header: 'Fi Pràctiques', key: 'DataFinalitzacio', width: 15 },
      { header: 'Check Inici', key: 'CheckTascaInici', width: 15 },
      { header: 'Check Final', key: 'CheckTascaFinal', width: 15 },
      { header: 'Observacions', key: 'Observacions', width: 30 },
      { header: 'Gener', key: 'Gener', width: 10 },
      { header: 'Febrer', key: 'Febrer', width: 10 },
      { header: 'Març', key: 'Març', width: 10 },
      { header: 'Abril', key: 'Abril', width: 10 },
      { header: 'Maig', key: 'Maig', width: 10 },
      { header: 'Juny', key: 'Juny', width: 10 },
      { header: 'Juliol', key: 'Juliol', width: 10 },
      { header: 'Agost', key: 'Agost', width: 10 },
      { header: 'Setembre', key: 'Setembre', width: 10 },
      { header: 'Octubre', key: 'Octubre', width: 10 },
      { header: 'Novembre', key: 'Novembre', width: 10 },
      { header: 'Desembre', key: 'Desembre', width: 10 },
    ];

    // Estilo de cabecera
    worksheet.getRow(1).eachCell((cell) => {
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFFFCC00' },
      };
      cell.font = { bold: true, color: { argb: 'FF0000FF' } };
      cell.alignment = { vertical: 'middle', horizontal: 'center' };
    });
    worksheet.getRow(1).height = 25;

    // Rellenar los datos y estilos de las filas
    formattedData.forEach((data, index) => {
      const row = worksheet.addRow(data);
      row.height = 25;
      if (index % 2 === 0) {
        row.eachCell((cell) => {
          cell.fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'FFF3F3F3' }, // Gris claro para filas alternas
          };
        });
      }
    });

    // Descargar el archivo Excel
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    saveAs(blob, 'Alumnes_Seleccionats.xlsx');
  } catch (error) {
    console.error('Error al descargar alumnos seleccionados:', error);
  }
};

const downloadSelectedStudentsAsText = async () => {
  const selectedIds = Object.keys(selectedRows).filter((key) => selectedRows[key]);

  if (selectedIds.length === 0) {
    console.log('No hay alumnos seleccionados para descargar');
    return;
  }

  let textData = '';

  try {
    const schoolsResponse = await fetch(process.env.REACT_APP_API_URL + '/schools/');
    const schoolsData = await schoolsResponse.json();

    const schoolDataMap = schoolsData.reduce((acc, school) => {
      acc[school.CODI] = school.CENTRE;
      return acc;
    }, {});

    const allStudentsResponse = await fetch(process.env.REACT_APP_API_URL + '/students/all');
    const allStudents = await allStudentsResponse.json();

    for (const id of selectedIds) {
      const student = allStudents.find((s) => s.ID_ALUMNES === parseInt(id));
      if (!student) {
        console.warn(`No se encontró información para el estudiante con ID: ${id}`);
        continue;
      }

      console.log('Datos del alumno seleccionado:', student);

      const formatDate = (dateString) => {
        if (!dateString) return '00000000';
        const date = new Date(dateString);
        return isNaN(date) ? '00000000' : format(date, 'yyyyMMdd');
      };

      // ===== REGISTRO DE ALTA (mateixa estructura que baixes, 2889 chars) =====

      const tipoRegistro = '01'; // 2 chars (pos 1-2)
      const codigoEmpresa = (student.CODI_CENTRE || '').padStart(5, '0'); // 5 chars (pos 3-7)
      const codigoTrabajo = (schoolDataMap[student.CODI_CENTRE] || '').padStart(5, '0'); // 5 chars (pos 8-12)
      const codigoTrabajador = (student.CODI_BECARI || '').padStart(6, '0'); // 6 chars (pos 13-18)

      // DATOS IDENTIFICACIÓN
      // IMPORTANT: netejar TABs, salts de línia i espais múltiples que descol·loquen el fitxer
      const dni = (student.DNI_NIE_PASSAPORT || '')
        .replace(/[\s\t\n\r]+/g, '') // Treu qualsevol whitespace
        .toUpperCase()
        .substring(0, 9)
        .padEnd(9, ' '); // 9 chars (pos 19-27)
      const apellidosNombre = (student.COGNOMS_NOM || '')
        .replace(/[\t\n\r]+/g, ' ') // Substitueix TABs i salts per espai
        .replace(',', '')
        .replace(/\s+/g, ' ') // Normalitza espais múltiples a un sol espai
        .trim()
        .toUpperCase()
        .substring(0, 30)
        .padEnd(30, ' '); // 30 chars (pos 28-57)

      const numMatricula = '00000'; // 5 chars (pos 58-62)

      // NÚMERO SEGURIDAD SOCIAL (12 chars: 2+8+2)
      const numSSCompleto = (student.NUM_SS || '').padStart(12, '0');
      const numSSP = numSSCompleto.substring(0, 2); // 2 chars (pos 63-64)
      const numSSN = numSSCompleto.substring(2, 10); // 8 chars (pos 65-72)
      const numSSD = numSSCompleto.substring(10, 12); // 2 chars (pos 73-74)

      const padre = '.'.padEnd(15, ' '); // 15 chars (pos 75-89)
      const madre = '.'.padEnd(15, ' '); // 15 chars (pos 90-104)
      const sexo = 'H'; // 1 char (pos 105)
      const estadoCivil = 'S'; // 1 char (pos 106)

      // DOMICILIO (pos 107-196 = 90 chars)
      const sigla = 'CL   '; // 5 chars (pos 107-111)
      const viaPublica = ''.padEnd(20, ' '); // 20 chars (pos 112-131)
      const numero = '    '; // 4 chars (pos 132-135)
      const escalera = '  '; // 2 chars (pos 136-137)
      const piso = '  '; // 2 chars (pos 138-139)
      const puerta = '  '; // 2 chars (pos 140-141)
      const municipio = 'BARCELONA'.padEnd(20, ' '); // 20 chars (pos 142-161)
      const provincia = 'BARCELONA'.padEnd(20, ' '); // 20 chars (pos 162-181)
      const cp = '08000'; // 5 chars (pos 182-186)
      const prefijoTel = '   '; // 3 chars (pos 187-189) - Prefix telèfon (buit, no és País)
      const telefono = '       '; // 7 chars (pos 190-196) - buit (només espais)

      // IRPF (pos 197-241 = 45 chars)
      const clavePercepcion = 'A'; // 1 char (pos 197)
      const numHijos = '00'; // 2 chars (pos 198-199)
      const porcRetencion = '00000'; // 5 chars (pos 200-204)
      const tipoRetencion = 'A'; // 1 char (pos 205)
      const porcBase = '00000'; // 5 chars (pos 206-210)
      const ingresosAnuales = '000000000'; // 9 chars (pos 211-219)
      const reserva1 = '000000'; // 6 chars (pos 220-225)
      const codigoSerie = '      '; // 6 chars (pos 226-231)
      const agrupacionHS = '          '; // 10 chars (pos 232-241)

      // CATEGORIA (pos 242-262 = 21 chars)
      const codCategoria = '000'; // 3 chars (pos 242-244)
      const denomCategoria = 'BECARI    '; // 10 chars (pos 245-254)
      const puestoTrabajo = 'BECARI  '; // 8 chars (pos 255-262)

      // COTIZACIÓN (pos 263-273 = 11 chars)
      const grupoTarifa = '07'; // 2 chars (pos 263-264)
      const epigrafeAccidentes = '113'; // 3 chars (pos 265-267)
      const tablaCalendario = '01'; // 2 chars (pos 268-269)
      const tipoCobro = 'M'; // 1 char (pos 270)
      const eventualPExtra = 'N'; // 1 char (pos 271)
      const ignorarTopeMin = 'N'; // 1 char (pos 272)
      const reserva2 = ' '; // 1 char (pos 273)

      // FECHAS (pos 274-313 = 40 chars)
      const fechaNacimiento = formatDate(student.DATA_NAIXAMENT); // 8 chars (pos 274-281)
      const fechaAntiguedad = formatDate(student.DATA_INICI); // 8 chars (pos 282-289)
      const fechaBaja = '00000000'; // 8 chars (pos 290-297) - ALTA: sense data de baixa
      const fechaIngreso = formatDate(student.DATA_INICI); // 8 chars (pos 298-305)
      const fechaAntiguedadCategoria = formatDate(student.DATA_INICI); // 8 chars (pos 306-313)

      // PLURIEMPLEO (pos 314-384 = 71 chars)
      const indicadorPluriempleo = 'N'; // 1 char
      const porcMinCC = '00000'; // 5 chars
      const porcMaxCC = '00000'; // 5 chars
      const porcMinAcc = '00000'; // 5 chars
      const porcMaxAcc = '00000'; // 5 chars
      const numAutorizacion = '0000000000'; // 10 chars
      const literalOtrasEmpresas = ''.padEnd(40, ' '); // 40 chars

      // TIEMPO PARCIAL (pos 385-400 = 16 chars)
      const indicadorTiempoParcial = 'D'; // 1 char
      const porcJornada = '00000'; // 5 chars
      const diasMes = '00000'; // 5 chars
      const horasMes = '00000'; // 5 chars

      // TRABAJADOR ADM LOCAL (pos 401-411 = 11 chars)
      const indicadorAdmLocal = 'N'; // 1 char
      const trieniosA = '00'; // 2 chars
      const trieniosB = '00'; // 2 chars
      const trieniosC = '00'; // 2 chars
      const trieniosD = '00'; // 2 chars
      const trieniosE = '00'; // 2 chars

      // COBRO POR BANCO (pos 412-497 = 86 chars)
      const numFormatoTalon = '00'; // 2 chars
      const codBancoPago = '0000'; // 4 chars
      const banco1Cod = '0000'; // 4 chars
      const banco1Agencia = '0000'; // 4 chars
      const banco1DCAgencia = '0'; // 1 char
      const banco1DCCuenta = '0'; // 1 char
      const banco1NumCuenta = '0000000000'; // 10 chars
      const banco2Cod = '0000'; // 4 chars
      const banco2Agencia = '0000'; // 4 chars
      const banco2DCAgencia = '0'; // 1 char
      const banco2DCCuenta = '0'; // 1 char
      const banco2NumCuenta = '0000000000'; // 10 chars
      const importeBanco2 = '0000000'; // 7 chars
      const conceptoBanco2 = '000'; // 3 chars
      const nombreBanco2 = ''.padEnd(30, ' '); // 30 chars

      // DATOS CONTRATO (pos 498-568 = 71 chars)
      const tipoContrato = '01'; // 2 chars (pos 498-499)
      const horasDia = '0100'; // 4 chars (pos 500-503)
      const fechaInicioContrato = formatDate(student.DATA_INICI); // 8 chars (pos 504-511)
      const fechaFinContrato = '20400101'; // 8 chars (pos 512-519) - DATA FIXA 01/01/2040
      const nivelEstudios = '53'; // 2 chars (pos 520-521)
      const descEstudios = '         '; // 9 chars (pos 522-530)
      const numContrato = '         '; // 9 chars (pos 531-539)
      const duracionInicial = '00'; // 2 chars (pos 540-541)
      const fechaRegistro = '00000000'; // 8 chars (pos 542-549)
      const diasNoComputables = '00000'; // 5 chars (pos 550-554)
      const numProrroga = '00'; // 2 chars (pos 555-556)
      const duracionProrroga = '00'; // 2 chars (pos 557-558)
      const acumuladoProrroga = '00'; // 2 chars (pos 559-560)
      const fechaUltimaProrroga = '00000000'; // 8 chars (pos 561-568)

      // BONIFICACIONES (pos 569-585 = 17 chars) - CODI RS
      const tipoBonificacion = 'S'; // 1 char (pos 569) - Segon caràcter de "RS"
      const fechaInicioBonif = formatDate(student.DATA_INICI); // 8 chars (pos 570-577)
      const fechaFinBonif = '20400101'; // 8 chars (pos 578-585) - DATA FIXA 01/01/2040

      // SUBVENCION INEM (pos 586-606 = 21 chars)
      const fechaInicioSubv = '00000000'; // 8 chars
      const fechaFinSubv = '00000000'; // 8 chars
      const importeSubv = '00000'; // 5 chars

      // DATOS PAGAS EXTRAS (pos 607-774 = 168 chars)
      const pagasExtras = '0'.repeat(168); // 168 chars

      // IMPUTACIÓN DE COSTOS (pos 775-966 = 192 chars)
      const imputacionCostos = ' '.repeat(192); // 192 chars

      // AMPLIACIÓN DE DATOS (pos 967-1266 = 300 chars)
      const ampliacionDatos = ' '.repeat(300); // 300 chars

      // AMPLIACIÓN IRPF (pos 1267-1287 = 21 chars)
      const pag1901 = '000'; // 3 chars
      const lin1901 = '000'; // 3 chars
      const pag1902 = '000'; // 3 chars
      const lin1902 = '000'; // 3 chars
      const pag1903 = '000'; // 3 chars
      const lin1903 = '000'; // 3 chars
      const codPaisTC = '724'; // 3 chars (pos 1285-1287) - Codi país ESPAÑA (omple "País" del Domicili a la fitxa A3)

      // AMPLIACIÓN TIEMPO PARCIAL (pos 1288-1332 = 45 chars)
      const ampliacionTP = ' '.repeat(45); // 45 chars

      // AMPLIACIÓN CONTRATO + BONIF + CONVENIO (pos 1333-1341 = 9 chars)
      const primerDigitoContrato = '0'; // 1 char (pos 1333)
      const primerCaracterBonif = 'R'; // 1 char (pos 1334) - Primer caràcter de "RS"
      const codConvenioColectivo = '0000000'; // 7 chars (pos 1335-1341)

      // CAMPOS INTERMEDIOS (pos 1342-1374 = 33 chars)
      const desempleo = '  '; // 2 chars
      const relLabEsp = '    '; // 4 chars
      const causaSustitucion = '  '; // 2 chars
      const mujerSubrep = 'N'; // 1 char
      const incapReadmitido = 'N'; // 1 char
      const primTrabAuton = 'N'; // 1 char
      const gradoMin = '  '; // 2 chars
      const trabExclSocial = ' '; // 1 char
      const subrogParcial = 'N'; // 1 char
      const nussTrabSust = '            '; // 12 chars
      const convContrato = 'N'; // 1 char
      const ctr7Dias = 'N'; // 1 char
      const baB2Ex = 'N'; // 1 char
      const indContrRelevo = 'N'; // 1 char
      const indTipoDoc = '01'; // 2 chars

      const camposIntermedios =
        desempleo + relLabEsp + causaSustitucion + mujerSubrep +
        incapReadmitido + primTrabAuton + gradoMin + trabExclSocial +
        subrogParcial + nussTrabSust + convContrato + ctr7Dias +
        baB2Ex + indContrRelevo + indTipoDoc; // Total: 33 chars

      // MOTIVO DE BAJA (pos 1375-1406 = 32 chars) - ALTA: sense motiu de baixa
      const codMotivoBaja = '00'; // 2 chars
      const motivoBajaTexto = ''.padEnd(30, ' '); // 30 chars

      // Camps addicionals (pos 1407-1910 = 504 chars)
      // IMPORTANT: dins d'aquest bloc cal informar:
      //   - pos 1546-1550: Codi Municipi TGSS (5 chars numèric) → '08019' Barcelona
      //   - pos 1551-1553: País Nacionalitat (3 chars numèric) → '724' ESPAÑA
      //   - pos 1567-1574: CNO Codi Ocupació TGSS (8 chars) → '3724    ' Monitors activ. recreatives
      const padFinsMunicipi = ' '.repeat(139);       // pos 1407-1545 (139 chars)
      const codiMunicipiTGSS = '08019';              // pos 1546-1550 (5 chars) - Barcelona
      const paisNacionalitat = '724';                // pos 1551-1553 (3 chars) - ESPAÑA
      const padFinsCNO = ' '.repeat(13);             // pos 1554-1566 (13 chars)
      const codigoCNO = '3724    ';                  // pos 1567-1574 (8 chars) - Monitors act. recreatives
      const padFinalExtra = ' '.repeat(336);         // pos 1575-1910 (336 chars)
      const camposExtra1 =
        padFinsMunicipi + codiMunicipiTGSS + paisNacionalitat +
        padFinsCNO + codigoCNO + padFinalExtra; // Total: 504 chars

      // BONIFICACIONES POSTERIORS A 07/2006 (pos 1911-1919 = 9 chars)
      const porcBonificacionApl = '10000'; // 5 chars - 100% bonificació (format 3e2d: 100.00)
      const colectivoBonif = '9927'; // 4 chars - Prácticas Académicas externas

      // RESTO (pos 1920-2889 = 970 chars)
      const restoFinalDefinitivo = ' '.repeat(970); // 970 chars

      // ===== CONSTRUCCIÓ DE LA LÍNIA (2889 chars exactes) =====
      const linea =
        tipoRegistro +                    // 1-2
        codigoEmpresa +                   // 3-7
        codigoTrabajo +                   // 8-12
        codigoTrabajador +                // 13-18
        dni +                             // 19-27
        apellidosNombre +                 // 28-57
        numMatricula +                    // 58-62
        numSSP +                          // 63-64
        numSSN +                          // 65-72
        numSSD +                          // 73-74
        padre +                           // 75-89
        madre +                           // 90-104
        sexo +                            // 105
        estadoCivil +                     // 106
        sigla +                           // 107-111
        viaPublica +                      // 112-131
        numero +                          // 132-135
        escalera +                        // 136-137
        piso +                            // 138-139
        puerta +                          // 140-141
        municipio +                       // 142-161
        provincia +                       // 162-181
        cp +                              // 182-186
        prefijoTel +                      // 187-189  prefix telèfon (buit)
        telefono +                        // 190-196  buit
        clavePercepcion +                 // 197
        numHijos +                        // 198-199
        porcRetencion +                   // 200-204
        tipoRetencion +                   // 205
        porcBase +                        // 206-210
        ingresosAnuales +                 // 211-219
        reserva1 +                        // 220-225
        codigoSerie +                     // 226-231
        agrupacionHS +                    // 232-241
        codCategoria +                    // 242-244
        denomCategoria +                  // 245-254
        puestoTrabajo +                   // 255-262
        grupoTarifa +                     // 263-264
        epigrafeAccidentes +              // 265-267
        tablaCalendario +                 // 268-269
        tipoCobro +                       // 270
        eventualPExtra +                  // 271
        ignorarTopeMin +                  // 272
        reserva2 +                        // 273
        fechaNacimiento +                 // 274-281
        fechaAntiguedad +                 // 282-289
        fechaBaja +                       // 290-297  ALTA: 00000000
        fechaIngreso +                    // 298-305
        fechaAntiguedadCategoria +        // 306-313
        indicadorPluriempleo +            // 314
        porcMinCC +                       // 315-319
        porcMaxCC +                       // 320-324
        porcMinAcc +                      // 325-329
        porcMaxAcc +                      // 330-334
        numAutorizacion +                 // 335-344
        literalOtrasEmpresas +            // 345-384
        indicadorTiempoParcial +          // 385
        porcJornada +                     // 386-390
        diasMes +                         // 391-395
        horasMes +                        // 396-400
        indicadorAdmLocal +               // 401
        trieniosA +                       // 402-403
        trieniosB +                       // 404-405
        trieniosC +                       // 406-407
        trieniosD +                       // 408-409
        trieniosE +                       // 410-411
        numFormatoTalon +                 // 412-413
        codBancoPago +                    // 414-417
        banco1Cod +                       // 418-421
        banco1Agencia +                   // 422-425
        banco1DCAgencia +                 // 426
        banco1DCCuenta +                  // 427
        banco1NumCuenta +                 // 428-437
        banco2Cod +                       // 438-441
        banco2Agencia +                   // 442-445
        banco2DCAgencia +                 // 446
        banco2DCCuenta +                  // 447
        banco2NumCuenta +                 // 448-457
        importeBanco2 +                   // 458-464
        conceptoBanco2 +                  // 465-467
        nombreBanco2 +                    // 468-497
        tipoContrato +                    // 498-499
        horasDia +                        // 500-503
        fechaInicioContrato +             // 504-511
        fechaFinContrato +                // 512-519  01/01/2040
        nivelEstudios +                   // 520-521
        descEstudios +                    // 522-530
        numContrato +                     // 531-539
        duracionInicial +                 // 540-541
        fechaRegistro +                   // 542-549
        diasNoComputables +               // 550-554
        numProrroga +                     // 555-556
        duracionProrroga +                // 557-558
        acumuladoProrroga +               // 559-560
        fechaUltimaProrroga +             // 561-568
        tipoBonificacion +                // 569      "S" de RS
        fechaInicioBonif +                // 570-577
        fechaFinBonif +                   // 578-585  01/01/2040
        fechaInicioSubv +                 // 586-593
        fechaFinSubv +                    // 594-601
        importeSubv +                     // 602-606
        pagasExtras +                     // 607-774
        imputacionCostos +                // 775-966
        ampliacionDatos +                 // 967-1266
        pag1901 +                         // 1267-1269
        lin1901 +                         // 1270-1272
        pag1902 +                         // 1273-1275
        lin1902 +                         // 1276-1278
        pag1903 +                         // 1279-1281
        lin1903 +                         // 1282-1284
        codPaisTC +                       // 1285-1287
        ampliacionTP +                    // 1288-1332
        primerDigitoContrato +            // 1333
        primerCaracterBonif +             // 1334     "R" de RS
        codConvenioColectivo +            // 1335-1341
        camposIntermedios +               // 1342-1374
        codMotivoBaja +                   // 1375-1376
        motivoBajaTexto +                 // 1377-1406
        camposExtra1 +                    // 1407-1910
        porcBonificacionApl +             // 1911-1915 "10000" (100%)
        colectivoBonif +                  // 1916-1919 "9927"
        restoFinalDefinitivo;             // 1920-2889

      // Verificació de longitud
      if (linea.length !== 2889) {
        console.error(`❌ Alumne ${student.CODI_BECARI}: Longitud incorrecta`);
        console.error(`   Esperada: 2889, Actual: ${linea.length}`);
        console.error(`   Diferencia: ${linea.length - 2889} caracteres`);
      } else {
        console.log(`✅ Alumne ${student.CODI_BECARI}: Longitud correcta (2889)`);
      }

      textData += linea + '\n';
    }

    const textBlob = new Blob([textData], { type: 'text/plain' });
    saveAs(textBlob, 'Alumnes_Seleccionats.txt');

    console.log(`✅ Archivo generado con ${selectedIds.length} altas`);

  } catch (error) {
    console.error('Error al generar el archivo TXT de altas:', error);
  }
};

const downloadSelectedStudentsAsBajas = async () => {
  const selectedIds = Object.keys(selectedRows).filter((key) => selectedRows[key]);

  if (selectedIds.length === 0) {
    console.log('No hay alumnos seleccionados para descargar');
    return;
  }

  let textData = '';

  try {
    const schoolsResponse = await fetch(process.env.REACT_APP_API_URL + '/schools/');
    const schoolsData = await schoolsResponse.json();

    const schoolDataMap = schoolsData.reduce((acc, school) => {
      acc[school.CODI] = school.CENTRE;
      return acc;
    }, {});

    const allStudentsResponse = await fetch(process.env.REACT_APP_API_URL + '/students/all');
    const allStudents = await allStudentsResponse.json();

    for (const id of selectedIds) {
      const student = allStudents.find((s) => s.ID_ALUMNES === parseInt(id));
      if (!student) {
        console.warn(`No se encontró información para el estudiante con ID: ${id}`);
        continue;
      }

      console.log('Datos del alumno seleccionado:', student);

      const formatDate = (dateString) => {
        if (!dateString) return '00000000';
        const date = new Date(dateString);
        return isNaN(date) ? '00000000' : format(date, 'yyyyMMdd');
      };

      // ===== REGISTRO DE BAJA =====
      
      const tipoRegistro = '01'; // 2 chars
      const codigoEmpresa = (student.CODI_CENTRE || '').padStart(5, '0'); // 5 chars
      const codigoTrabajo = (schoolDataMap[student.CODI_CENTRE] || '').padStart(5, '0'); // 5 chars
      const codigoTrabajador = (student.CODI_BECARI || '').padStart(6, '0'); // 6 chars
      
      // DATOS IDENTIFICACIÓN
      // IMPORTANT: netejar TABs, salts de línia i espais múltiples que descol·loquen el fitxer
      const dni = (student.DNI_NIE_PASSAPORT || '')
        .replace(/[\s\t\n\r]+/g, '') // Treu qualsevol whitespace
        .toUpperCase()
        .substring(0, 9)
        .padEnd(9, ' '); // 9 chars
      const apellidosNombre = (student.COGNOMS_NOM || '')
        .replace(/[\t\n\r]+/g, ' ') // Substitueix TABs i salts per espai
        .replace(',', '')
        .replace(/\s+/g, ' ') // Normalitza espais múltiples a un sol espai
        .trim()
        .toUpperCase()
        .substring(0, 30)
        .padEnd(30, ' '); // 30 chars
      
      const numMatricula = '00000'; // 5 chars
      
      // NÚMERO SEGURIDAD SOCIAL (12 chars divididos en 2+8+2)
      const numSSCompleto = (student.NUM_SS || '').padStart(12, '0');
      const numSSP = numSSCompleto.substring(0, 2); // 2 chars - Provincia
      const numSSN = numSSCompleto.substring(2, 10); // 8 chars - Número
      const numSSD = numSSCompleto.substring(10, 12); // 2 chars - Dígito control
      
      const padre = '.'.padEnd(15, ' '); // 15 chars
      const madre = '.'.padEnd(15, ' '); // 15 chars
      const sexo = 'H'; // 1 char
      const estadoCivil = 'S'; // 1 char
      
      // DOMICILIO (107-196 = 90 chars)
      const sigla = 'CL   '; // 5 chars
      const viaPublica = ''.padEnd(20, ' '); // 20 chars
      const numero = '    '; // 4 chars
      const escalera = '  '; // 2 chars
      const piso = '  '; // 2 chars
      const puerta = '  '; // 2 chars
      const municipio = 'BARCELONA'.padEnd(20, ' '); // 20 chars
      const provincia = 'BARCELONA'.padEnd(20, ' '); // 20 chars
      const cp = '08000'; // 5 chars
      const prefijoTel = '   '; // 3 chars (pos 187-189) - Prefix telèfon (buit, no és País)
      const telefono = '       '; // 7 chars - buit (només espais)

      // IRPF (197-241 = 45 chars)
      const clavePercepcion = 'A'; // 1 char
      const numHijos = '00'; // 2 chars
      const porcRetencion = '00000'; // 5 chars
      const tipoRetencion = 'A'; // 1 char
      const porcBase = '00000'; // 5 chars
      const ingresosAnuales = '000000000'; // 9 chars
      const reserva1 = '000000'; // 6 chars
      const codigoSerie = '      '; // 6 chars
      const agrupacionHS = '          '; // 10 chars
      
      // CATEGORIA (242-262 = 21 chars)
      const codCategoria = '000'; // 3 chars
      const denomCategoria = 'BECARI    '; // 10 chars
      const puestoTrabajo = 'BECARI  '; // 8 chars
      
      // COTIZACIÓN (263-273 = 11 chars)
      const grupoTarifa = '07'; // 2 chars
      const epigrafeAccidentes = '113'; // 3 chars
      const tablaCalendario = '01'; // 2 chars
      const tipoCobro = 'M'; // 1 char
      const eventualPExtra = 'N'; // 1 char
      const ignorarTopeMin = 'N'; // 1 char
      const reserva2 = ' '; // 1 char
      
      // FECHAS (274-313 = 40 chars)
      const fechaNacimiento = formatDate(student.DATA_NAIXAMENT); // 8 chars
      const fechaAntiguedad = formatDate(student.DATA_INICI); // 8 chars
      const fechaBaja = formatDate(student.DATA_FINALITZACIO); // 8 chars  FECHA DE BAJA REAL
      const fechaIngreso = formatDate(student.DATA_INICI); // 8 chars
      const fechaAntiguedadCategoria = formatDate(student.DATA_INICI); // 8 chars
      
      // PLURIEMPLEO (314-384 = 71 chars)
      const indicadorPluriempleo = 'N'; // 1 char
      const porcMinCC = '00000'; // 5 chars
      const porcMaxCC = '00000'; // 5 chars
      const porcMinAcc = '00000'; // 5 chars
      const porcMaxAcc = '00000'; // 5 chars
      const numAutorizacion = '0000000000'; // 10 chars
      const literalOtrasEmpresas = ''.padEnd(40, ' '); // 40 chars
      
      // TIEMPO PARCIAL (385-400 = 16 chars)
      const indicadorTiempoParcial = 'D'; // 1 char
      const porcJornada = '00000'; // 5 chars
      const diasMes = '00000'; // 5 chars
      const horasMes = '00000'; // 5 chars
      
      // TRABAJADOR ADM LOCAL (401-411 = 11 chars)
      const indicadorAdmLocal = 'N'; // 1 char
      const trieniosA = '00'; // 2 chars
      const trieniosB = '00'; // 2 chars
      const trieniosC = '00'; // 2 chars
      const trieniosD = '00'; // 2 chars
      const trieniosE = '00'; // 2 chars
      
      // COBRO POR BANCO (412-497 = 86 chars)
      const numFormatoTalon = '00'; // 2 chars
      const codBancoPago = '0000'; // 4 chars
      const banco1Cod = '0000'; // 4 chars
      const banco1Agencia = '0000'; // 4 chars
      const banco1DCAgencia = '0'; // 1 char
      const banco1DCCuenta = '0'; // 1 char
      const banco1NumCuenta = '0000000000'; // 10 chars
      const banco2Cod = '0000'; // 4 chars
      const banco2Agencia = '0000'; // 4 chars
      const banco2DCAgencia = '0'; // 1 char
      const banco2DCCuenta = '0'; // 1 char
      const banco2NumCuenta = '0000000000'; // 10 chars
      const importeBanco2 = '0000000'; // 7 chars
      const conceptoBanco2 = '000'; // 3 chars
      const nombreBanco2 = ''.padEnd(30, ' '); // 30 chars
      
      // DATOS CONTRATO (498-568 = 71 chars)
      const tipoContrato = '01'; // 2 chars
      const horasDia = '0100'; // 4 chars
      const fechaInicioContrato = formatDate(student.DATA_INICI); // 8 chars
      const fechaFinContrato = '20400101'; // 8 chars  DATA FIXA 01/01/2040
      const nivelEstudios = '53'; // 2 chars
      const descEstudios = '         '; // 9 chars
      const numContrato = '         '; // 9 chars
      const duracionInicial = '00'; // 2 chars
      const fechaRegistro = '00000000'; // 8 chars
      const diasNoComputables = '00000'; // 5 chars
      const numProrroga = '00'; // 2 chars
      const duracionProrroga = '00'; // 2 chars
      const acumuladoProrroga = '00'; // 2 chars
      const fechaUltimaProrroga = '00000000'; // 8 chars
      
      //  BONIFICACIONES (569-585 = 17 chars) - CÓDIGO RS
      const tipoBonificacion = 'S'; // 1 char - Últim dígit de "RS"
      const fechaInicioBonif = formatDate(student.DATA_INICI); // 8 chars
      const fechaFinBonif = '20400101'; // 8 chars  DATA FIXA 01/01/2040
      
      // SUBVENCION INEM (586-606 = 21 chars)
      const fechaInicioSubv = '00000000'; // 8 chars
      const fechaFinSubv = '00000000'; // 8 chars
      const importeSubv = '00000'; // 5 chars
      
      // DATOS PAGAS EXTRAS (607-774 = 168 chars)
      const pagasExtras = '0'.repeat(168); // 168 chars
      
      // IMPUTACIÓN DE COSTOS (775-966 = 192 chars)
      const imputacionCostos = ' '.repeat(192); // 192 chars
      
      // AMPLIACIÓN DE DATOS (967-1266 = 300 chars)
      const ampliacionDatos = ' '.repeat(300); // 300 chars
      
      // AMPLIACIÓN IRPF (1267-1287 = 21 chars)
      const pag1901 = '000'; // 3 chars
      const lin1901 = '000'; // 3 chars
      const pag1902 = '000'; // 3 chars
      const lin1902 = '000'; // 3 chars
      const pag1903 = '000'; // 3 chars
      const lin1903 = '000'; // 3 chars
      const codPaisTC = '724'; // 3 chars (pos 1285-1287) - Codi país ESPAÑA (omple "País" del Domicili a la fitxa A3)
      
      // AMPLIACIÓN TIEMPO PARCIAL (1288-1332 = 45 chars)
      const ampliacionTP = ' '.repeat(45); // 45 chars
      
      // AMPLIACIÓN CONTRATO + BONIF + CONVENIO (1333-1341 = 9 chars)
      const primerDigitoContrato = '0'; // 1 char
      const primerCaracterBonif = 'R'; // 1 char -  Primer caràcter de "RS"
      const codConvenioColectivo = '0000000'; // 7 chars
      
      //  CAMPOS INTERMEDIOS (1342-1374 = 33 chars)
      const desempleo = '  '; // 2 chars - Posició 1342-1343
      const relLabEsp = '    '; // 4 chars - Posició 1344-1347
      const causaSustitucion = '  '; // 2 chars - Posició 1348-1349 (només per substitucions)
      const mujerSubrep = 'N'; // 1 char - Posició 1350
      const incapReadmitido = 'N'; // 1 char - Posició 1351
      const primTrabAuton = 'N'; // 1 char - Posició 1352
      const gradoMin = '  '; // 2 chars - Posició 1353-1354
      const trabExclSocial = ' '; // 1 char - Posició 1355
      const subrogParcial = 'N'; // 1 char - Posició 1356
      const nussTrabSust = '            '; // 12 chars - Posició 1357-1368
      const convContrato = 'N'; // 1 char - Posició 1369
      const ctr7Dias = 'N'; // 1 char - Posició 1370
      const baB2Ex = 'N'; // 1 char - Posició 1371
      const indContrRelevo = 'N'; // 1 char - Posició 1372
      const indTipoDoc = '01'; // 2 chars - Posició 1373-1374
      
      const camposIntermedios = 
        desempleo + 
        relLabEsp + 
        causaSustitucion + 
        mujerSubrep + 
        incapReadmitido + 
        primTrabAuton + 
        gradoMin + 
        trabExclSocial + 
        subrogParcial + 
        nussTrabSust + 
        convContrato + 
        ctr7Dias + 
        baB2Ex + 
        indContrRelevo + 
        indTipoDoc; // Total: 33 chars
      
      // MOTIVO DE BAJA (1375-1406 = 32 chars)
      // CRÍTIC: El codi 54 controla la "Situación del Motivo" al tràmit TGSS
      // Si es posa '00', A3 assigna per defecte 51 (Dimisión/Baja voluntaria) - INCORRECTE
      // Ha de ser '54' perquè TGSS rebi: 54 - BAJA BECARIOS - NO VOLUNTARIA
      const codMotivoBaja = '54'; // 2 chars - Causa 54: Baja Becarios - No Voluntaria (TGSS)
      const motivoBajaTexto = 'BAJA BECARIOS - NO VOLUNTARIA '.substring(0, 30); // 30 chars
      
      // Camps addicionals fins arribar a posició 1911 (1407-1910 = 504 chars)
      // IMPORTANT: dins d'aquest bloc cal informar:
      //   - pos 1546-1550: Codi Municipi TGSS (5 chars numèric) → '08019' Barcelona
      //   - pos 1551-1553: País Nacionalitat (3 chars numèric) → '724' ESPAÑA
      //   - pos 1567-1574: CNO Codi Ocupació TGSS (8 chars) → '3724    ' Monitors activ. recreatives
      const padFinsMunicipi = ' '.repeat(139);       // pos 1407-1545 (139 chars)
      const codiMunicipiTGSS = '08019';              // pos 1546-1550 (5 chars) - Barcelona
      const paisNacionalitat = '724';                // pos 1551-1553 (3 chars) - ESPAÑA
      const padFinsCNO = ' '.repeat(13);             // pos 1554-1566 (13 chars)
      const codigoCNO = '3724    ';                  // pos 1567-1574 (8 chars) - Monitors act. recreatives
      const padFinalExtra = ' '.repeat(336);         // pos 1575-1910 (336 chars)
      const camposExtra1 =
        padFinsMunicipi + codiMunicipiTGSS + paisNacionalitat +
        padFinsCNO + codigoCNO + padFinalExtra; // Total: 504 chars

      // 🔥 BONIFICACIONES POSTERIORES A 07/2006 (1911-1919 = 9 chars)
      const porcBonificacionApl = '10000'; // 5 chars - 100% bonificació (format: 3e2d = 100.00)
      const colectivoBonif = '9927'; // 4 chars -  Codi 9927 = Prácticas Académicas externas
      
      // RESTO HASTA COMPLETAR 2889 (1920-2889 = 970 chars)
      const restoFinalDefinitivo = ' '.repeat(970); // 970 chars
      
      // ===== CONSTRUCCIÓN DE LA LÍNEA =====
      const linea = 
        tipoRegistro +                    // 1-2
        codigoEmpresa +                   // 3-7
        codigoTrabajo +                   // 8-12
        codigoTrabajador +                // 13-18
        dni +                             // 19-27
        apellidosNombre +                 // 28-57
        numMatricula +                    // 58-62
        numSSP +                          // 63-64
        numSSN +                          // 65-72
        numSSD +                          // 73-74
        padre +                           // 75-89
        madre +                           // 90-104
        sexo +                            // 105
        estadoCivil +                     // 106
        sigla +                           // 107-111
        viaPublica +                      // 112-131
        numero +                          // 132-135
        escalera +                        // 136-137
        piso +                            // 138-139
        puerta +                          // 140-141
        municipio +                       // 142-161
        provincia +                       // 162-181
        cp +                              // 182-186
        prefijoTel +                      // 187-189  prefix telèfon (buit)
        telefono +                        // 190-196  buit
        clavePercepcion +                 // 197
        numHijos +                        // 198-199
        porcRetencion +                   // 200-204
        tipoRetencion +                   // 205
        porcBase +                        // 206-210
        ingresosAnuales +                 // 211-219
        reserva1 +                        // 220-225
        codigoSerie +                     // 226-231
        agrupacionHS +                    // 232-241
        codCategoria +                    // 242-244
        denomCategoria +                  // 245-254
        puestoTrabajo +                   // 255-262
        grupoTarifa +                     // 263-264
        epigrafeAccidentes +              // 265-267
        tablaCalendario +                 // 268-269
        tipoCobro +                       // 270
        eventualPExtra +                  // 271
        ignorarTopeMin +                  // 272
        reserva2 +                        // 273
        fechaNacimiento +                 // 274-281
        fechaAntiguedad +                 // 282-289
        fechaBaja +                       // 290-297 DATA REAL DE BAIXA
        fechaIngreso +                    // 298-305
        fechaAntiguedadCategoria +        // 306-313
        indicadorPluriempleo +            // 314
        porcMinCC +                       // 315-319
        porcMaxCC +                       // 320-324
        porcMinAcc +                      // 325-329
        porcMaxAcc +                      // 330-334
        numAutorizacion +                 // 335-344
        literalOtrasEmpresas +            // 345-384
        indicadorTiempoParcial +          // 385
        porcJornada +                     // 386-390
        diasMes +                         // 391-395
        horasMes +                        // 396-400
        indicadorAdmLocal +               // 401
        trieniosA +                       // 402-403
        trieniosB +                       // 404-405
        trieniosC +                       // 406-407
        trieniosD +                       // 408-409
        trieniosE +                       // 410-411
        numFormatoTalon +                 // 412-413
        codBancoPago +                    // 414-417
        banco1Cod +                       // 418-421
        banco1Agencia +                   // 422-425
        banco1DCAgencia +                 // 426
        banco1DCCuenta +                  // 427
        banco1NumCuenta +                 // 428-437
        banco2Cod +                       // 438-441
        banco2Agencia +                   // 442-445
        banco2DCAgencia +                 // 446
        banco2DCCuenta +                  // 447
        banco2NumCuenta +                 // 448-457
        importeBanco2 +                   // 458-464
        conceptoBanco2 +                  // 465-467
        nombreBanco2 +                    // 468-497
        tipoContrato +                    // 498-499
        horasDia +                        // 500-503
        fechaInicioContrato +             // 504-511
        fechaFinContrato +                // 512-519 01/01/2040
        nivelEstudios +                   // 520-521
        descEstudios +                    // 522-530
        numContrato +                     // 531-539
        duracionInicial +                 // 540-541
        fechaRegistro +                   // 542-549
        diasNoComputables +               // 550-554
        numProrroga +                     // 555-556
        duracionProrroga +                // 557-558
        acumuladoProrroga +               // 559-560
        fechaUltimaProrroga +             // 561-568
        tipoBonificacion +                // 569 "S" de RS
        fechaInicioBonif +                // 570-577
        fechaFinBonif +                   // 578-585  01/01/2040
        fechaInicioSubv +                 // 586-593
        fechaFinSubv +                    // 594-601
        importeSubv +                     // 602-606
        pagasExtras +                     // 607-774
        imputacionCostos +                // 775-966
        ampliacionDatos +                 // 967-1266
        pag1901 +                         // 1267-1269
        lin1901 +                         // 1270-1272
        pag1902 +                         // 1273-1275
        lin1902 +                         // 1276-1278
        pag1903 +                         // 1279-1281
        lin1903 +                         // 1282-1284
        codPaisTC +                       // 1285-1287
        ampliacionTP +                    // 1288-1332
        primerDigitoContrato +            // 1333
        primerCaracterBonif +             // 1334  "R" de RS
        codConvenioColectivo +            // 1335-1341
        camposIntermedios +               // 1342-1374
        codMotivoBaja +                   // 1375-1376  "54"
        motivoBajaTexto +                 // 1377-1406  BUIT (descripció automàtica)
        camposExtra1 +                    // 1407-1910
        porcBonificacionApl +             // 1911-1915  "10000" (100%)
        colectivoBonif +                  // 1916-1919  "9927"
        restoFinalDefinitivo;             // 1920-2889

      // Verificación detallada
      if (linea.length !== 2889) {
        console.error(`❌ Alumne ${student.CODI_BECARI}: Longitud incorrecta`);
        console.error(`   Esperada: 2889, Actual: ${linea.length}`);
        console.error(`   Diferencia: ${linea.length - 2889} caracteres`);
      } else {
        console.log(`✅ Alumne ${student.CODI_BECARI}: Longitud correcta (2889)`);
      }

      textData += linea + '\n';
    }

    const textBlob = new Blob([textData], { type: 'text/plain' });
    saveAs(textBlob, 'Baixes_Becaris.txt');
    
    console.log(`✅ Archivo generado con ${selectedIds.length} bajas`);
    
  } catch (error) {
    console.error('Error al generar el archivo TXT de bajas:', error);
  }
};

const exportFilteredMonth = async () => {
  try {
    const filters = JSON.parse(localStorage.getItem('studentsTableFilters'));
    const dataIniciFilter = filters.find(f => f.id === 'data_inici');
    const dataFinalFilter = filters.find(f => f.id === 'data_finalitzacio');

    if (!dataIniciFilter || !dataFinalFilter || !Array.isArray(dataIniciFilter.value) || !Array.isArray(dataFinalFilter.value)) {
      console.warn('Faltan filtros de fecha válidos');
      return;
    }

    const [startInici, endInici] = dataIniciFilter.value;
    const [startFinal, endFinal] = dataFinalFilter.value;

    const endDateInici = endInici ? new Date(endInici) : null;
    const startDateFinal = startFinal ? new Date(startFinal) : null;

    if (!endDateInici || !startDateFinal) {
      console.warn('Fechas inválidas');
      return;
    }

    const month = endDateInici.getMonth();
    const finalMonth = startDateFinal.getMonth();
    if (month !== finalMonth) {
      console.warn('El cruce de fechas no da un mes común');
      return;
    }

    // Nombres de campos en inglés para los datos de la API
    const monthKeys = [
      'January', 'February', 'March', 'April', 'May', 'June',
      'July', 'August', 'September', 'October', 'November', 'December'
    ];

    // Encabezados legibles en catalán
    const monthHeaders = [
      'Gener', 'Febrer', 'Març', 'Abril', 'Maig', 'Juny',
      'Juliol', 'Agost', 'Setembre', 'Octubre', 'Novembre', 'Desembre'
    ];

    const targetKey = monthKeys[month];         // Ej: "April"
    const targetHeader = monthHeaders[month];   // Ej: "Abril"

    // Cargar todos los datos desde la API
    const response = await fetch(process.env.REACT_APP_API_URL + '/students/all');
    const allStudents = await response.json();

    // Filtrar los alumnos visibles según filtros actuales
    const filteredStudents = filteredRows
      .filter(row => {
        const isLocked = lockedStudentIds.includes(row.original.ID_ALUMNES);
        if (filterStatus === 'habilitados') return !isLocked;
        if (filterStatus === 'inhabilitados') return isLocked;
        return true;
      })
      .map(row => {
        const fullData = allStudents.find(s => s.ID_ALUMNES === row.original.ID_ALUMNES);
        return {
          ...row.original,
          ...fullData
        };
      });

    // Comprobación de si los datos contienen el campo esperado
    console.log('TargetKey:', targetKey);
    console.log('Ejemplo student:', filteredStudents[0]);
    if (!filteredStudents[0] || !(targetKey in filteredStudents[0])) {
      console.warn(`El campo "${targetKey}" no está en los datos del alumno.`);
    }

    // Crear Excel
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Mes Filtrat');

    worksheet.columns = [
      { header: 'Codi Becari', key: 'CODI_BECARI', width: 15 },
      { header: 'DNI', key: 'DNI_NIE_PASSAPORT', width: 15 },
      { header: 'NOM', key: 'COGNOMS_NOM', width: 30 },
      { header: targetHeader, key: targetHeader, width: 10 }
    ];

    filteredStudents.forEach(student => {
      worksheet.addRow({
        CODI_BECARI: student.CODI_BECARI ? `0${student.CODI_BECARI}` : '',
        DNI_NIE_PASSAPORT: student.DNI_NIE_PASSAPORT,
        COGNOMS_NOM: student.COGNOMS_NOM,
        [targetHeader]: student[targetKey] ?? 0
      });
    });

    worksheet.getRow(1).eachCell(cell => {
      cell.font = { bold: true };
      cell.alignment = { vertical: 'middle', horizontal: 'center' };
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFFFCC00' }
      };
    });

    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    });
    saveAs(blob, `Alumnes_${targetHeader}.xlsx`);
  } catch (error) {
    console.error('Error exportando mes filtrado:', error);
  }
};




const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    state: { filters, pageSize, pageIndex },
    filteredRows,  // Datos filtrados
    nextPage,
    previousPage,
    canNextPage,
    canPreviousPage,
    pageOptions,
    setPageSize,
    setAllFilters,
  } = useTable(
    {
      columns,
      data,
      // filterTypes: { dateBetween: dateBetweenFilterFn },
      filterTypes: {
        exactText: (rows, id, filterValue) => {
          return rows.filter(row => {
            const rowValue = row.values[id];
            return String(rowValue) === String(filterValue); // Comparación exacta
          });
        },
        dateBetween: dateBetweenFilterFn,
        // otros filtros personalizados...
      },
      initialState: {
      filters: JSON.parse(localStorage.getItem('studentsTableFilters')) || [], // Usar filtros guardados
      pageSize: 25,
    },
    },
    useGlobalFilter,
    useFilters,
    useSortBy,
    usePagination
  );
  // Efecto para guardar los filtros cuando cambian
  useEffect(() => {
    handleFiltersChange(filters);
  }, [filters]);

  // Detect which month the 'dades creuades' filter targets (null if not active)
  const cruzadasMonthKey = (() => {
    const monthKeysEN = ['January','February','March','April','May','June','July','August','September','October','November','December'];
    const dataIniciF = filters.find(f => f.id === 'data_inici');
    const dataFinalF = filters.find(f => f.id === 'data_finalitzacio');
    if (!Array.isArray(dataIniciF?.value) || !Array.isArray(dataFinalF?.value)) return null;
    const endInici = dataIniciF.value[1];
    const startFinal = dataFinalF.value[0];
    if (!endInici || !startFinal) return null;
    const m1 = new Date(endInici).getMonth();
    const m2 = new Date(startFinal).getMonth();
    return m1 === m2 ? monthKeysEN[m1] : null;
  })();

  return (
    <div className="flex flex-col">
      <div className="flex items-center justify-between w-full px-4">
        {/* Botón para seleccionar o deseleccionar todos */}
        <button
          onClick={handleSelectAll}
          className="font-bold rounded-lg text-white bg-indigo-800 mb-4 px-4 py-3 cursor-pointer transition duration-300 ease-in-out transform hover:bg-indigo-600 hover:shadow-lg hover:scale-105"
        >
          {selectAll ? 'Desseleccionar tots els alumnes' : 'Seleccionar tots els alumnes'}
        </button>

        {/* Botón para borrar */}
        <button
          type="button"
          className="font-bold rounded-lg text-white bg-indigo-800 mb-4 px-4 py-3 cursor-pointer transition duration-300 ease-in-out transform hover:bg-indigo-600 hover:shadow-lg hover:scale-105"
          onClick={() => {
            setAllFilters([]);
            setSelectedRows({}); 
            setSelectAll(false);
            columns.forEach((column) => {
              localStorage.setItem(column.accessor, undefined);
              // localStorage.removeItem(column.id);
            });
          }}
        >
          Esborrar filtres
        </button>
      </div>
      
      <div className="align-middle inline-block min-w-full">
        <table
          className="table-auto min-w-full border-2 border-indigo-800"
          {...getTableProps()}
        >
          <thead className="bg-indigo-900">
            {headerGroups.map((headerGroup) => (
              <tr
                className="divide-x divide-dashed divide-indigo-600"
                key={headerGroup.id}
                {...headerGroup.getHeaderGroupProps()}
              >
                {(user.role_id === 1 || user.role_id === 2) && (
                  <th className="text-white py-2 hover:bg-indigo-800 font-ms-semi flex-center">
                    <div className="text-left text-sm ml-4 mr-4">
                      <select
                        value={filterStatus}
                        style={{ width: '100%' }}
                        onChange={(e) => setFilterStatus(e.target.value)}
                        className="bg-indigo-700 text-white rounded p-1 cursor-pointer"
                      >
                        <option value="">Tots</option>
                        <option value="habilitados">Habilitats</option>
                        <option value="inhabilitados">Deshabilitats</option>
                      </select>
                    </div>
                  </th>
                )}
                {headerGroup.headers.map((column) => (
                  <th
                    className="text-white py-2 hover:bg-indigo-800 font-ms-semi"
                    key={column.id}
                    {...column.getHeaderProps(column.getSortByToggleProps({ title: undefined }))}
                  >
                    <div className="text-left text-sm ml-4 flex items-center">
                      {column.render('Header')}
                      {column.isSorted ? (
                        column.isSortedDesc ? (
                          <FilterDown width={10} height={10} className="inline-block ml-1 -mt-1" fill="black" />
                        ) : (
                          <FilterUp width={10} height={10} className="inline-block ml-1 -mt-1" fill="black" />
                        )
                      ) : null}
                    </div>
                    <div className="mx-4">
                      {column.canFilter ? column.render('Filter') : null}
                    </div>
                  </th>
                ))}
                <th className="text-white py-2 hover:bg-indigo-800 font-ms-semi flex-center">
                  <div className="text-left text-sm ml-4">Calendari</div>
                </th>
              </tr>
            ))}
          </thead>

            <tbody
              style={{ borderColor: '#9CA3AF' }}
              className="bg-white divide-y divide-gray-200"
              {...getTableBodyProps()}
            >
              {page
                .filter((row) => {
                  const isLocked = lockedStudentIds.includes(row.original.ID_ALUMNES);
                  if (filterStatus === 'habilitados') return !isLocked;
                  if (filterStatus === 'inhabilitados') return isLocked;
                  return true;
                })
                .map((row, index) => {
                  prepareRow(row);
                  const studentId = row.original.ID_ALUMNES;
                  const isRowLocked = lockedStudentIds.includes(studentId);
                  const disableRow = isRowLocked && user.role_id === 1; // Solo bloquea interacción para role_id === 1

                  return (
                    <tr
                      key={row.id}
                      {...row.getRowProps()}
                      onClick={(e) => !disableRow && handleClick && handleClick(e, row.original)} // Bloquea interacción según role_id
                      className={`hover:bg-indigo-200 hover:font-bold cursor-pointer divide-x divide-dashed divide-indigo-200
                        ${isRowLocked ? 'bg-red-300' : index % 2 === 0 ? 'bg-indigo-50' : ''}`} // Fondo rojo si está bloqueado
                    >
                      {(user.role_id === 1 || user.role_id === 2) && (
                        <td
                          className="text-sm font-medium text-center cursor-pointer"
                          style={{ width: '6.25%' }}
                          onClick={(e) => {
                            e.stopPropagation();
                            handleCheckboxClick(row); // Permitir selección incluso si está bloqueado
                          }}
                        >
                          <input
                            type="checkbox"
                            checked={!!selectedRows[studentId]}
                            readOnly
                            onClick={(e) => {
                              e.stopPropagation();
                              handleCheckboxClick(row); // Maneja la selección
                            }}
                            className="cursor-pointer form-checkbox h-5 w-5 text-indigo-800"
                          />
                        </td>
                      )}
                      {/* {row.cells.map((cell) => (
                        <td
                          key={cell.column.id}
                          className={`text-sm font-medium py-4 ${
                            cell.column.id === 'checks_center_inici' || cell.column.id === 'checks_center_final'
                              ? ''
                              : 'pl-4'
                          }`}
                          style={{ width: cell.column.width || '12.5%' }}
                        >
                          {disableRow ? (
                            <span>{cell.render('Cell')}</span> // Mostrar valor, sin opción de editar
                          ) : (
                            cell.render('Cell') // Células editables si no está bloqueado
                          )}
                        </td>
                      ))} */}

                      {(() => {
                        const rowKey = `${row.original.CODI_CENTRE}_${row.original.CODI_BECARI}`;

                        // CAS 1: mateix DNI + dates de pràctiques solapades
                        const rowIsOverlap = overlapRows.has(rowKey);

                        // CAS 2: mateix DNI + el nou període comença el mateix mes que acaba l'anterior
                        const rowIsMonthAdjacent = monthAdjacentRows.has(rowKey);

                        return row.cells.map((cell) => {
                          const isDniColumn =
                            cell.column.id === 'DNI' ||
                            cell.column.id === 'DNI_NIE_PASSAPORT';

                          const isDateColumn =
                            cell.column.Type === 'data_inici' ||
                            cell.column.Type === 'data_finalitzacio';

                          // Només marquem DNI + dates en els casos 1 i 2
                          const highlight =
                            (isDniColumn || isDateColumn) &&
                            (rowIsOverlap || rowIsMonthAdjacent);

                          return (
                            <td
                              key={cell.column.id}
                              className={`text-sm font-medium py-4 ${
                                cell.column.id === 'checks_center_inici' || cell.column.id === 'checks_center_final'
                                  ? ''
                                  : 'pl-4'
                              } ${
                                highlight
                                  ? rowIsOverlap
                                    ? 'ring-4 ring-inset ring-[rgba(199,13,44,1)]' // 🔴 CAS 1
                                    : 'ring-4 ring-inset ring-amber-600' // 🟡 CAS 2 (rgba(217,119,6,1) = amber-600 exacto)
                                  : ''
                              }`}
                              style={{ width: cell.column.width || '12.5%' }}
                            >
                              {disableRow ? (
                                <span>{cell.render('Cell')}</span>
                              ) : (
                                cell.render('Cell')
                              )}
                            </td>
                          );
                        });
                      })()}
                      
                      <td className="text-sm font-medium text-center" style={{ width: '6.25%' }}>
                        <button
                          onClick={(e) => {
                            e.stopPropagation();
                            handleCalendarClick(row.original); // Permitir acceso al calendario
                          }}
                          className="text-indigo-800 hover:text-blue-700"
                        >
                          <FaCalendarAlt size={24} />
                        </button>
                      </td>
                    </tr>
                  );
                })}
            </tbody>


          <tfoot>
            <tr>
              <td colSpan={columns.length + 2} className="p-0 m-0">
                <StudentsTableBar
                  previousPage={previousPage}
                  canPreviousPage={canPreviousPage}
                  pageIndex={pageIndex}
                  pageOptions={pageOptions}
                  nextPage={nextPage}
                  canNextPage={canNextPage}
                  pageSize={pageSize}
                  setPageSize={setPageSize}
                  // datos={data}
                  // datos={filteredRows.map(row => row.original)}
                  datos={filteredRows // Para que habilitados - deshabilitados se pasen como un filtro mas para el Excel
                    .filter((row) => {
                      const isLocked = lockedStudentIds.includes(row.original.ID_ALUMNES);

                      if (filterStatus === 'habilitados') return !isLocked; // Solo habilitados
                      if (filterStatus === 'inhabilitados') return isLocked; // Solo inhabilitados
                      return true; // Todos si no hay filtro
                    })
                    .map((row) => row.original)}
                  onSuccess={refreshData}
                  onSuccessPracts={refreshData}
                  activeMonthKey={cruzadasMonthKey}
                />
              </td>
            </tr>
          </tfoot>
        </table>
      </div>


{Object.keys(selectedRows).length > 0 && (
  <div className="w-full bg-indigo-100 border border-indigo-300 text-indigo-800 rounded-t-md px-6 mt-2 py-2 mb-0 shadow-sm flex justify-center items-center gap-2">
    <svg
      className="w-5 h-5 text-indigo-600"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      viewBox="0 0 24 24"
    >
      <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
    </svg>
    <span className="font-semibold text-sm">
      {Object.keys(selectedRows).length} alumne
      {Object.keys(selectedRows).length > 1 ? 's seleccionats' : ' seleccionat'}
    </span>
  </div>
)}


{/* {Object.keys(selectedRows).some((key) => selectedRows[key]) && (
  <div className="mt-4 flex w-full"> */}
  {Object.keys(selectedRows).length > 0 && (
  <div className="mt-4 flex w-full">
    {user.role_id === 1 ? (
      // Role 1: Descargar Plantilla Prácticas y Eliminar Alumnes
      <>
        {/* Botón "Descarregar Plantilla Pràctiques" */}
        <div className="w-1/2 flex items-center mr-2">
          <button
            className="font-bold rounded-lg text-white"
            style={{
              width: '85px',
              marginRight: '-60px',
              height: '85px',
              zIndex: 2,
            }}
            onClick={downloadSelectedPractices}
          >
            <img
              src={logoExcelRound}
              alt="icon"
              style={{ width: '65px', height: '65px' }}
            />
          </button>
          <label
            className="font-bold rounded-lg text-white bg-[#4DA462] px-4 py-3 cursor-pointer transition duration-300 ease-in-out transform hover:bg-[#308446] hover:shadow-lg hover:scale-10 flex-grow"
            onClick={downloadSelectedPractices}
            style={{ paddingLeft: '45px' }}
          >
            Descarregar Plantilla Pràctiques
          </label>
        </div>

        {/* Botón "Eliminar Alumnes" */}
        <div className="w-1/2 flex items-center ml-2">
          <button
            className="font-bold rounded-lg text-white"
            style={{
              width: '85px',
              marginRight: '-60px',
              height: '85px',
              zIndex: 2,
            }}
            onClick={handleDeleteModalForSelected}
          >
            <img
              src={logoBorrarRound}
              alt="delete-icon"
              style={{ width: '60px', height: '60px' }}
            />
          </button>
          <label
            className="font-bold rounded-lg text-white bg-red-600 px-4 py-3 cursor-pointer transition duration-300 ease-in-out transform hover:bg-red-800 hover:shadow-lg hover:scale-10 flex-grow"
            onClick={handleDeleteModalForSelected}
            style={{ paddingLeft: '45px' }}
          >
            Eliminar Alumnes
          </label>
        </div>
      </>
    ) : (
      // Role 2: Cambiar Check, Descargar Alumnos, Descargar TXT, Eliminar Alumnos
      <>
      <div className="flex w-full items-stretch flex-wrap">
        {/* Botón para cambiar el "Check Tasca Inici y Final" */}
        <div className="w-[18%] flex items-center ml-3">
          <button
            className="font-bold rounded-lg text-white"
            style={{
              width: '85px',
              marginRight: '-60px',
              height: '85px',
              zIndex: 2,
            }}
            onClick={() => setShowForm(true)}
          >
            <img
              src={logoCheckRound}
              alt="check-icon"
              style={{ width: '60px', height: '60px' }}
            />
          </button>
          <label
            className="font-bold rounded-lg text-white bg-[#191970] px-4 py-3 cursor-pointer transition duration-300 ease-in-out transform hover:bg-[#000080] hover:shadow-lg hover:scale-10 flex-grow"
            onClick={() => setShowForm(true)}
            style={{ paddingLeft: '45px' }}
          >
            Canvis Checks
          </label>
        </div>

        {/* Botón "Descarregar alumnes seleccionats" */}
        <div className="w-[18%] flex items-center ml-3">
          <button
            className="font-bold rounded-lg text-white"
            style={{
              width: '85px',
              marginRight: '-60px',
              height: '85px',
              zIndex: 2,
            }}
            onClick={downloadSelectedStudents}
          >
            <img
              src={logoExcelRound}
              alt="excel-icon"
              style={{ width: '65px', height: '65px' }}
            />
          </button>
          <label
            className="font-bold rounded-lg text-white bg-[#4DA462] px-4 py-3 cursor-pointer transition duration-300 ease-in-out transform hover:bg-[#308446] hover:shadow-lg hover:scale-10 flex-grow"
            onClick={downloadSelectedStudents}
            style={{ paddingLeft: '45px' }}
          >
            Excel Seleccionats
          </label>
        </div>

        {/* Botón "Descarregar TXT alumnes seleccionats" */}
        <div className="w-[18%] flex items-center ml-3">
          <button
            className="font-bold rounded-lg text-white"
            style={{
              width: '85px',
              marginRight: '-60px',
              height: '85px',
              zIndex: 2,
            }}
            onClick={downloadSelectedStudentsAsText}
          >
            <img
              src={logoAltas}
              alt="txt-icon"
              style={{ width: '75px', height: '70px' }}
            />
          </button>
          <label
            className="font-bold rounded-lg text-white bg-[#134e4a] px-4 py-3 cursor-pointer transition duration-300 ease-in-out transform hover:bg-[#133f3c] hover:shadow-lg hover:scale-10 flex-grow"
            onClick={downloadSelectedStudentsAsText}
            style={{ paddingLeft: '55px' }}
          >
            TXT Altas
          </label>
        </div>

        {/* Botón "TXT alumnes baixa" */}
        <div className="w-[18%] flex items-center ml-3">
          <button
            className="font-bold rounded-lg text-white"
            style={{
              width: '85px',
              marginRight: '-60px',
              height: '85px',
              zIndex: 2,
            }}
            onClick={downloadSelectedStudentsAsBajas}
          >
            <img
              src={logoBajas}
              alt="txt-icon"
              style={{ width: '75px', height: '70px' }}
            />
          </button>
          <label
            className="font-bold rounded-lg text-white bg-[#881337] px-4 py-3 cursor-pointer transition duration-300 ease-in-out transform hover:bg-[#54061d] hover:shadow-lg hover:scale-10 flex-grow"
            onClick={downloadSelectedStudentsAsBajas}
            style={{ paddingLeft: '55px' }}
          >
            TXT Baixes
          </label>
        </div>



{/* Botón "Descarregar Excel dades creuades" */}
 <div className="w-[18%] flex items-center ml-3">
        <button
          className="font-bold rounded-lg text-white"
          style={{
            width: '85px',
            marginRight: '-60px',
            height: '85px',
            zIndex: 2,
          }}
          onClick={exportFilteredMonth} // Función para eliminar handleDeleteSelectedStudents
        >
          <img
            src={logoCalendar} // Ruta al logo de borrar
            alt="delete-icon"
            style={{ width: '60px', height: '60px' }} // Ajusta el tamaño según sea necesario
          />
        </button>
        <label
          className="font-bold rounded-lg text-white bg-orange-500 px-4 py-3 cursor-pointer transition duration-300 ease-in-out transform hover:bg-orange-800 hover:shadow-lg hover:scale-10 flex-grow"
          onClick={exportFilteredMonth} // handleDeleteSelectedStudents
          style={{ paddingLeft: '45px' }} // Ajusta el espacio a la izquierda para acomodar la imagen
        >
          Mensual (dades creuades)
        </label>
        </div>

        {/* Botón "Eliminar Alumnes" reducido */}
        {/* <div className="w-1/3 flex items-center ml-2">
        <button
          className="font-bold rounded-lg text-white"
          style={{
            width: '85px',
            marginRight: '-60px',
            height: '85px',
            zIndex: 2,
          }}
          onClick={handleDeleteModalForSelected} // Función para eliminar handleDeleteSelectedStudents
        >
          <img
            src={logoBorrarRound} // Ruta al logo de borrar
            alt="delete-icon"
            style={{ width: '60px', height: '60px' }} // Ajusta el tamaño según sea necesario
          />
        </button>
        <label
          className="font-bold rounded-lg text-white bg-red-600 px-4 py-3 cursor-pointer transition duration-300 ease-in-out transform hover:bg-red-800 hover:shadow-lg hover:scale-10 flex-grow"
          onClick={handleDeleteModalForSelected} // handleDeleteSelectedStudents
          style={{ paddingLeft: '45px' }} // Ajusta el espacio a la izquierda para acomodar la imagen -- test
        >
          Eliminar Alumnes
        </label>
        </div> */}

        {/* Botón solo redondo (sin texto) "Eliminar Alumnes" */}
        <div className="flex items-center justify-center ml-6">
        <button
          className="font-bold rounded-lg text-white"
          style={{
            width: '85px',
            marginRight: '-60px',
            height: '85px',
            zIndex: 2,
          }}
          onClick={handleDeleteModalForSelected} // Función para eliminar handleDeleteSelectedStudents
        >
          <img
            src={logoBorrarRound} // Ruta al logo de borrar
            alt="delete-icon"
            style={{ width: '60px', height: '60px' }} // Ajusta el tamaño según sea necesario
          />
        </button>
        </div>
        </div>
      </>
    )}
  </div>
)}







      {showForm && user.role_id === 2 && (
        <div ref={formRef} className="mt-6 bg-indigo-100 p-6 rounded-lg shadow-lg max-w-lg mx-auto">
          <h3 className="text-indigo-900 font-bold text-lg mb-4">Actualitzar Estat</h3>
          <label htmlFor="iniciCheck" className="block text-sm font-semibold text-indigo-800 mb-2">
            Selecciona el nou estat de Check Tasca Inici:
          </label>
          <select
            id="iniciCheck"
            value={iniciCheck}
            onChange={handleIniciCheckChange}
            className="block w-full px-4 py-2 border border-indigo-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm transition ease-in-out duration-200"
          >
            <option value="">Selecciona una opció</option>
            <option value="0">No</option>
            <option value="1">Sí</option>
            <option value="2">Pendent</option>
          </select>

          <label htmlFor="fiCheck" className="block text-sm font-semibold text-indigo-800 mt-6 mb-2">
            Selecciona el nou estat de Check Tasca Final:
          </label>
          <select
            id="fiCheck"
            value={fiCheck}
            onChange={handleFiCheckChange}
            className="block w-full px-4 py-2 border border-indigo-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm transition ease-in-out duration-200"
          >
            <option value="">Selecciona una opció</option>
            <option value="0">No</option>
            <option value="1">Sí</option>
            <option value="2">Pendent</option>
          </select>

          <button onClick={handleApplyChanges} className="w-full mt-6 bg-indigo-600 hover:bg-indigo-700 text-white font-semibold py-3 rounded-md shadow-lg transition ease-in-out duration-200 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2">
            Aplicar canvis
          </button>
        </div>
      )}
    </div>
  );
}

StudentsTable.propTypes = {
  columns: PropTypes.array.isRequired,
  data: PropTypes.array.isRequired,
  handleClick: PropTypes.func,
  refreshData: PropTypes.func.isRequired,
  duplicateDNIs: PropTypes.instanceOf(Set),
  overlapRows: PropTypes.instanceOf(Set),
  monthAdjacentRows: PropTypes.instanceOf(Set)
};
